import { FormattedMessage } from 'react-intl'
import { useMutation, useApolloClient, gql } from '@apollo/client'
import styled from 'styled-components'

import { Button } from 'components/v2/Button'
import Modal from 'components/v2/Modal'
import Heading from 'components/v2/Heading'
import { ErrorMessage } from 'components/v2/ErrorMessage'
import { InStockError } from 'features/Inventories/components/InStockError'
import { resolvers as ordersResolvers } from 'resolvers/orders'
import { getUnprocessableErrors, isInStockError } from 'utils/error'

const ModalContainer = styled(Modal.Container)`
  max-width: 600px;
`

const SHIP_ORDER = gql`
  mutation ShipOrder($orderId: ID!) {
    shipOrder(input: { id: $orderId })
  }
`

const SHIP_LOCAL_ORDER = gql`
  mutation ShipLocalOrder($orderId: ID!) {
    shipOrder(orderId: $orderId) @client
  }
`

const INCREASE_PENDING_ORDERS_COUNT = gql`
  mutation IncreasePendingOrdersCount($inventoryId: ID!) {
    increasePendingOrdersCount(inventoryId: $inventoryId) @client
  }
`

export const ShipOrderModal = ({ order, inventoryId, closeModal }: TSFixMe): TSFixMe => {
  let inStockErrors: TSFixMe = []
  let filteredUnprocessableErrors: TSFixMe = []
  const client = useApolloClient()
  client.addResolvers(ordersResolvers)

  const [shipLocalOrder] = useMutation(SHIP_LOCAL_ORDER)
  const [increasePendingOrdersCount] = useMutation(INCREASE_PENDING_ORDERS_COUNT)
  const [shipOrder, { loading, error }] = useMutation(SHIP_ORDER, {
    onCompleted() {
      shipLocalOrder({
        variables: {
          orderId: order.id
        }
      })
      increasePendingOrdersCount({
        variables: {
          inventoryId
        }
      })
      closeModal()
    }
  })

  const handleShipOrder = (): TSFixMe => {
    shipOrder({
      variables: {
        orderId: order.id
      }
    })
  }

  if (error) {
    const unprocessableErrors = getUnprocessableErrors(error)
    filteredUnprocessableErrors = unprocessableErrors.filter((unprocessableError): TSFixMe => {
      return !isInStockError(unprocessableError)
    })
    inStockErrors = unprocessableErrors.filter((unprocessableError): TSFixMe => {
      return isInStockError(unprocessableError)
    })
  }

  return (
    <ModalContainer large>
      <Modal.Header>
        <Heading.H5>
          <FormattedMessage
            id="spanish.orders.send.title"
            defaultMessage="Enviar orden {id}"
            values={{
              id: order.id.substring(0, 8)
            }}
          />
        </Heading.H5>
      </Modal.Header>

      <Modal.Content>
        <FormattedMessage
          id="spanish.orders.send.confirmMessage"
          defaultMessage="¿Estás seguro de enviar los productos a la ubicación {destination}?"
          values={{
            destination: order.destination.name
          }}
        />
      </Modal.Content>

      <Modal.Footer>
        <Modal.ErrorMessage>
          <InStockError errors={inStockErrors} />
        </Modal.ErrorMessage>
        {error && inStockErrors.length === 0 && (
          <Modal.ErrorMessage>
            <ErrorMessage errors={filteredUnprocessableErrors}>
              <FormattedMessage
                id="spanish.orders.send.error"
                defaultMessage="Hubo un error interna. Intenta de nuevo."
              />
            </ErrorMessage>
          </Modal.ErrorMessage>
        )}
        <Modal.Actions>
          <Button kind="cancel" onClick={(): TSFixMe => closeModal()}>
            <FormattedMessage id="spanish.dictionary.close" defaultMessage="Cerrar" />
          </Button>
          <Button kind="primary" loading={loading} onClick={handleShipOrder}>
            <FormattedMessage id="spanish.orders.send.action" defaultMessage="Enviar" />
          </Button>
        </Modal.Actions>
      </Modal.Footer>
    </ModalContainer>
  )
}
